import React from 'react';
import {
  GRAPH_CONTRACT_COLOR,
  GRAPH_MONTH_COLOR,
  GRAPH_QUARTER_COLOR,
  GRAPH_RELEASED_COLOR,
  GRAPH_RELEASING_COLOR,
  GRAPH_TRADING_COLOR,
  GRAPH_YEAR_COLOR,
} from '../../constants/colors';
import { graphColumns } from './utils/utils';
import { useIntl } from 'react-intl';
import TradeChart from './TradeChart';
import { BOUGHT_CHART_INTL_KEY } from '../BoughtChart/contants';
import PropTypes from 'prop-types';

const BuyChart = ({ className, data, year, config }) => {
  const intl = useIntl();

  const seriesConfig = {
    [graphColumns.CONTRACT]: {
      color: GRAPH_CONTRACT_COLOR,
      name: 'CONTRACT',
      tooltipLabel: 'CONTRACT TOOLTIP',
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.contracted_volume_name`,
        defaultMessage: 'Contracted volume',
      }),
    },
    [graphColumns.ANNUAL]: {
      color: GRAPH_YEAR_COLOR,
      name: 'ANNUAL',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.yearly_volume_name`,
        defaultMessage: 'Yearly volume',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.yearly_volume_name`,
        defaultMessage: 'Yearly volume',
      }),
    },
    [graphColumns.QUARTER]: {
      color: GRAPH_QUARTER_COLOR,
      name: 'QUARTER',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.quarterly_volume_name`,
        defaultMessage: 'Quarter volume',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.quarterly_volume_name`,
        defaultMessage: 'Quarter volume',
      }),
    },
    [graphColumns.MONTH]: {
      color: GRAPH_MONTH_COLOR,
      name: 'MONTH',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.monthly_volume_name`,
        defaultMessage: 'Month product',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.monthly_volume_name`,
        defaultMessage: 'Month product',
      }),
    },
    [graphColumns.TRADING]: {
      color: GRAPH_TRADING_COLOR,
      name: 'TRADING',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.currently_buying`,
        defaultMessage: 'Buying product',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.currently_buying`,
        defaultMessage: 'Buying product',
      }),
    },
    [graphColumns.RELEASE]: {
      color: GRAPH_RELEASED_COLOR,
      name: 'RELEASED',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.released_volume`,
        defaultMessage: 'Released product',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.released_volume`,
        defaultMessage: 'Released product',
      }),
    },
    [graphColumns.RELEASING]: {
      color: GRAPH_RELEASING_COLOR,
      name: 'RELEASING',
      tooltipLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.currently_releasing`,
        defaultMessage: 'Releasing product',
      }),
      legendLabel: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.currently_releasing`,
        defaultMessage: 'Releasing product',
      }),
    },
  };


  return <TradeChart className={className} seriesConfig={seriesConfig} config={config} data={data} year={year} />;
};

BuyChart.propTypes = {
  className: PropTypes.string,
  year: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      productType: PropTypes.string,
      quantities: PropTypes.arrayOf(
        PropTypes.shape({
          month: PropTypes.number,
          quantity: PropTypes.number,
        }),
      ),
    }),
  ),
  config: PropTypes.shape({
    hideYAxesScale: PropTypes.bool,
    hideYAxesName: PropTypes.bool,
  }),
};

export default BuyChart;
